import { combineReducers } from "redux";
import ProfileDetailsReducer from "@redux/feature/Profile/reducer/profileDetailReducer";
import clientRatingSummary from "@redux/feature/Profile/reducer/clientRatingSummary";
import RMDetailsRatingReducer from "@redux/feature/Profile/reducer/rmDetailsRatingReducer";
import CreaticalActivityReducer from "@redux/feature/Profile/reducer/creaticalActivityReducer";
import RatingDetailReducer from "@redux/feature/Profile/reducer/ratingDetailReducer";
import createNamedWrapperReducer from "@redux/feature/Markets/Equity/wrapperReducer";
import RouteDetailsReducer from "./reducer/RouteDetailsReducer";
export default combineReducers({
    ProfileDetails: createNamedWrapperReducer(ProfileDetailsReducer, "ProfileDetails"),
    RouteDetails: createNamedWrapperReducer(RouteDetailsReducer, "RouteDetails"),
    clientRatingSummary: clientRatingSummary,
    RMDetailsRatingReducer: RMDetailsRatingReducer,
    CreaticalActivityReducer: CreaticalActivityReducer,
    RatingDetailReducer: RatingDetailReducer,
});
